<template>
  <div class="manual-entry-page">
    <circle-stage>
      <template slot="headline">
        {{ $t('ManualEntry.headline') }}
      </template>
      <p>
        {{ $t('ManualEntry.description') }}
      </p>
      <form @submit.prevent="process">
        <pin-input
          :length="codeLength"
          :error="codeInputError"
          :loading="codeInputLoading"
          :placeholder="'#'"
          type="text"
          transform="uppercase"
          v-model="codeInput"
          @submit="process"
        />
        <span v-if="codeInputLoading">
          <p>
            {{ $t('ManualEntry.loading') }}
          </p>
          <!-- this is just a placeholder so that the layout never jumps -->
          <p>&nbsp;</p>
        </span>
        <span v-else-if="codeInputError">
          <p class="error">
            {{ $t('ManualEntry.error') }}
          </p>
          <p>
            {{ $t('ManualEntry.retry') }}
          </p>
        </span>
        <span v-else>
          <!-- this is just a placeholder so that the layout never jumps -->
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </span>
      </form>
    </circle-stage>
  </div>
</template>

<script>
import CircleStage from '@/components/CircleStage/CircleStage.vue';
import PinInput from '@/components/PinInput/PinInput.vue';

export default {
  name: 'ManualEntry',
  components: {
    CircleStage,
    PinInput,
  },
  data: () => ({
    codeLength: 6,
    codeInput: '',
    codeInputError: false,
    codeInputLoading: false,
  }),
  watch: {
    codeInput(v) {
      if (v.length !== this.codeLength) {
        this.codeInputLoading = false;
      }
    },
  },
  created() {
    const checkForError = (error) => {
      this.codeInputError = (error === 'error');
    };
    this.$watch(
      () => this.$route.params.error,
      checkForError,
    );
    checkForError(this.$route.params.error);
  },
  methods: {
    process() {
      const isCodeOk = (code) => code && code.length === this.codeLength;

      const proceed = () => {
        const code = this.codeInput.trim();
        if (isCodeOk(code)) {
          this.$nextTick(() => {
            this.$router.push({
              name: 'Processing',
              params: { authenticationCode: code },
            })
              // route guard intervention might fire (unhandled) exceptions
              // which are totally fine but need to be handled for Cypress
              .catch(() => {});
          });
        }
      };

      // wait a bit before processing this
      // so that a user has the chance to fix a typo

      if (this.timer) {
        window.clearTimeout(this.timer);
      }

      const code = this.codeInput.trim();
      if (isCodeOk(code)) {
        this.codeInputLoading = true;
        this.timer = window.setTimeout(proceed, 1200);
      }
    },
  },
};
</script>

<style lang="scss">
.error {
  color: var(--colors-error-font);
}
</style>
